"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var GamepadContext_1 = __importDefault(require("./GamepadContext"));
var useGamepad = function () {
    return (0, react_1.useContext)(GamepadContext_1.default);
};
exports.default = useGamepad;
